import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { observeTranslations } from './locales'

import Vue3Toasity from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import 'vuetify/dist/vuetify.min.css'

loadFonts()

// Crear app solo una vez
const app = createApp(App)

app.use(router)
app.use(store)
app.use(vuetify)
app.use(Vue3Toasity)
app.mount('#app')
observeTranslations()

window.addEventListener("load", () => { // Quitar el preloader cuando Vue termina de montar
    const loader = document.getElementById("preloader");
    if (loader) {
        setTimeout(() => {
            loader.style.opacity = "0";
            setTimeout(() => loader.remove(), 500); // espera al fade-out
        }, 3000); // 3000 ms = 3 segundos
    }
});
